import { render, staticRenderFns } from "./SuccessAuxilios.vue?vue&type=template&id=c7abeb4e&scoped=true&"
import script from "./SuccessAuxilios.vue?vue&type=script&lang=js&"
export * from "./SuccessAuxilios.vue?vue&type=script&lang=js&"
import style0 from "./SuccessAuxilios.vue?vue&type=style&index=0&id=c7abeb4e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7abeb4e",
  null
  
)

export default component.exports